import { __awaiter, __generator } from "tslib";
var StargateClient = /** @class */ (function () {
    function StargateClient(baseUrl) {
        this.baseUrl = baseUrl || '/gateway/api';
    }
    StargateClient.prototype.fetchToken = function (clientId) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, fetch(this.baseUrl + "/media/auth/smartedge", {
                            credentials: 'include',
                            headers: {
                                'x-client-id': clientId,
                            },
                        })];
                    case 1: return [2 /*return*/, (_a.sent()).json()];
                }
            });
        });
    };
    StargateClient.prototype.isTokenExpired = function (token) {
        var currentTimeInSeconds = new Date().getTime() / 1000;
        return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
    };
    return StargateClient;
}());
export { StargateClient };
//# sourceMappingURL=stargate-client.js.map